<!--
Author: ia
Create Time: 2019-07-19 11:57:15
Description: 附件列表
-->
<template>
  <div class="com-accessory-list">
    <div class="docManagerWrap-Top">
      <div style="padding: 10px 10px 10px 20px">
        <!-- <el-tooltip class="item" effect="dark" content="刷新" placement="top">
          <i class="el-icon-refresh" style="padding-left: 10px;cursor: pointer;" @click="search()"></i>
        </el-tooltip> -->
        <!-- <el-tooltip class="item" effect="dark" content="上传" placement="top">
          <i
            @click="uploadOpen()"
            class="iconfont"
            style="padding-left: 10px;cursor: pointer;"
          >&#xe601;</i>      
        </el-tooltip>
        <p>
          <el-link :underline="false"
            @click="uploadOpen()"
          >
            上传
          </el-link>
        </p> -->
        <el-button type="primary" size="medium" icon="el-icon-upload" @click="uploadOpen()">上传</el-button>
      </div>
      <div class="docManagerWrap-Bottom">
        <div class="docManagerWrap-Bottom-table" style="padding-bottom: 2em;">
          <el-table
            :height="320"
            style="min-height: 320px;max-height: 550px; overflow-y: scroll;"
            :stripe="true"
            :header-cell-style="{background:'#F2F2F2',color:'#606266'}"
            :data="pageData.list"
          >
            <el-table-column type="index" width="60" label="序号" align="center" show-overflow-tooltip></el-table-column>
            <el-table-column prop="fileName" label="文件名" :width="280" show-overflow-tooltip></el-table-column>
            <el-table-column prop="classifyName" label="附件分类" show-overflow-tooltip>
              <template slot-scope="scope">
                <span>{{(findTreeNodeById(scope.row.classifyId, treeData) || {}).classifyName}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="fileSize" label="文件大小(KB)" show-overflow-tooltip></el-table-column>
            <el-table-column align="center" width="220" prop="uploadUser" show-overflow-tooltip label="上传者">
              <template slot-scope="scope">
                <span>{{(findTreeNodeById(scope.row.uploadUser, uploadUserData) || {}).userName}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="fileFormat" label="文档格式" v-if="false" show-overflow-tooltip></el-table-column>
            <el-table-column prop="uploadTime" label="上传时间" show-overflow-tooltip></el-table-column>
            <el-table-column prop label="操作" show-overflow-tooltip>
              <template slot-scope="scope">
                <!-- 
                <el-tooltip class="item" effect="dark" content="预览" placement="top">
                  <el-button
                    size="medium"
                    type="text"
                    icon="el-icon-view"
                    class="btnIcon"
                    @click="handlePreviewFile(scope.row)"
                  ></el-button>
                </el-tooltip>
                -->
                <el-tooltip class="item" effect="dark" content="下载" placement="top">
                  <el-button
                    size="medium"
                    type="text"
                    icon="el-icon-download"
                    class="red btnIcon"
                    @click="handleDownload(scope.row)"
                  ></el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="删除" placement="top">
                  <el-button
                    size="medium"
                    type="text"
                    icon="el-icon-delete"
                    class="red btnIcon"
                    @click="handleDeleteFile(scope.row)"
                  ></el-button>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- <div class="pagination">
          <pagination style="float:right" :page-list="pageData" @pagesearch="handlePage"></pagination>
        </div> -->
      </div>
    </div>

    <div class="uploadDialog">
      <el-dialog title="提示" :visible.sync="isUploadDialogVisible" width="60%" :modal="true" append-to-body>
        <div class="page" style="padding-top: 6px;">
          <el-col>
            <el-form :model="docTypeForm" ref="docTypeForm" inline>
              <el-form-item
                style="position: absolute;width: 50%;"
                label="附件分类"
                prop="docType"
                class="item-5"
              >
                <treeSelect
                  :data="treeData"
                  :top="false"
                  v-model="docTypeForm.docType"
                  label="classifyName"
                  :onlyChildren="true"
                ></treeSelect>
               
              </el-form-item>
            </el-form>
          </el-col>
          <div :id="uploadButtonId" ref="filePicker" style="margin-top: 50px;" :style="{visibility: (this.docTypeForm.docType ? 'visible' : 'hidden')}">选择文件</div>
          <div class="file-panel" style="width: 100%!important;">
            <h2>文件列表</h2>
            <div class="file-list" style="height: 260px;">
              <ul
                class="file-item"
                :class="`file-${file.id}`"
                v-for="file in this.fileList"
                :key="file.id"
              >
                <li class="file-type"></li>
                <li class="file-name">{{file.name}}</li>
                <li class="file-size">{{fileSize(file.size)}}</li>
                <li class="file-status" style="float:right">待上传...</li>
                <li class="file-operate">
                  <a title="开始" @click="startUploadFile(file)">
                    <i style="font-size: 20px;" class="el-icon-video-play"></i>
                  </a>
                  <a title="暂停" @click="stopUploadFile(file)">
                    <i style="font-size: 20px;" class="el-icon-video-pause"></i>
                  </a>
                  <a title="移除" @click="removeUploadFile(file)">
                    <i style="font-size: 20px;" class="el-icon-close"></i>
                  </a>
                </li>

                <li class="progress"></li>
              </ul>
              <div class="no-file" v-if="!this.fileList.length">
                <i class="iconfont icon-empty-file"></i> 暂无待上传文件
              </div>
            </div>
          </div>
          <!-- FTP上传接口 url="bohee/bop/api/system/accessoryinfo/uploadfile" -->
          <vue-upload
            ref="uploader"
            url="bohee/bop/api/system/sysFile/uploadChunk"
            :uploadButton="'#' + uploadButtonId"
            multiple
            @fileChange="fileChange"
            @progress="onProgress"
            @success="onSuccess"
            @error="onError"
            :fileSingleSizeLimit="1024 * (1024 * 1000)"
          ></vue-upload>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="isUploadDialogVisible = false">返 回</el-button>
        </span>
      </el-dialog>
    </div><!-- end dialog -->
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "accessoryList",
  props: {
    businessId: String,
    belongtoProjectId: String,
    belongtoProjectName: String,
  },
  data() {
    return {
      ipUrl: "",
      searchStyle: 200,
      searchStatus: true,
      uploadUserData: [], //上传人列表
      fileList: [], //文件列表
      businessIds:"", //业务ID
      docTypeForm: {
        docType: ""
      },
      searchConditionForm: {
        //查询条件
        keyword: "",
        uploadUser: "",
        fileFormat: ""
      },
      treeData: [], //附件分类
      // currentClickNode: "", //当前点击节点
      uploadedFileList: [], //已上传文件
      uploadFlag: false, //标记是否有文件正在上传
      uploadError: false, //文件上传是否出现异常
      isUploadDialogVisible: false,
      pageData: {
        list: []
        // pageNumber: 1,
        // pageSize: 10,
        // totalCount: 0,
        // totalPage: 0
      },
      uploadButtonId: `ub-${Date.now()}`
    };
  },
  created() {
    this.init();
  },
  activated() {
    this.init();
  },
  watch: {

  },
  methods: {
    init() {
      //查询附件分类
      this.getTreeData();
      //查询上传人列表
      this.$http.get(this.api.queryAllUser).then(res => {
        if (res.data.code == "200") {
          this.uploadUserData = res.data.body;
        } else {
          this.$message.error(res.data.body);
        }
      });
    },
    getData(businessId) {
      //页面存储业务id，方便删除时调用查询
      this.businessIds = businessId;
      return this.$http
        .post(this.api.accessoryInfoQueryByBusinessId + businessId)
        .then(res => {
          if (res.data.code === "200") {           
             if(res.data.body.records == ""){
                this.pageData.list =[];
             }
            this.pageData.list = res.data.body.records;
            //this.pageData.totalCount = res.data.body.total;
            //this.pageData.totalPage = res.data.body.pages;
          }
        });
    },

    //打开文件上传窗口
    uploadOpen() {
      this.docTypeForm.docType = "";
      this.fileList = [];
      this.isUploadDialogVisible = true;
    },

    //删除附件
    handleDeleteFile(file) {
      this.$confirm("确认删除附件？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          if(this.belongtoProjectName != file.classifyName){
            return this.$message.error("节点名称与附件分类不符，不可删除！")
          }else{
            this.$http.post(this.api.accessoryInfoDelete, file).then(res => {
            if (res.data.code == "200") {
              this.$message.success(res.data.body);
              // 201909021428 如果传入了有效的 businessId 则重新查询附件列表
              if (this.businessIds && !this.businessIds.startsWith('-')) {
                this.getData(this.businessIds).then(() => {
                  this.$emit('update:addFileList', this.pageData.list)
                });
              } else {
                const idx = this.pageData.list.indexOf(file);
                if (idx > -1) {
                  // 在 列表中 删除 这个文件
                  this.pageData.list.splice(idx, 1);
                  this.$emit('update:addFileList', this.pageData.list)
                }
              }
              
            } else {
              this.$message.error(res.data.body);
            }
          });
          }
          
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    handlePage(number, size) {
      this.search(number, size);
    },

    getTreeData() {
      this.$http.get(this.api.accessoryclassifyQueryAll).then(res => {
        if (res.data.code == "200") {
          this.treeData = res.data.body;
        } else {
          this.$message.error(res.data.body);
        }
      }); 
      
    },
    //--------------------文件上传相关方法 start
    fileChange(file) {
      if (!file.size) {
        return;
      }
      this.fileList.push(file);
    },
    onProgress(file, percent) {
      //file-WU_FILE_0  WU_FILE_0
      this.uploadFlag = true; //标记有文件正在上传
      if(percent == 1){
           $(`.file-${file.id} .progress`).css("width", percent * 100 + "%");
           $(`.file-${file.id} .file-status`).html("正在上传中...");
      }else{
           $(`.file-${file.id} .progress`).css("width", percent * 100 + "%");
           $(`.file-${file.id} .file-status`).html((percent * 100).toFixed(2) + "%");
      }
    },

    onSuccess(file, response) {
      if (response.code == "200") {
        const _this = this;
        var date = new Date();
        var year = date.getFullYear();
        var month = date.getMonth() + 1;
        var day = date.getDate();
        if (month < 10) {
          month = "0" + month;
        }
        var day = date.getDate();
        if (day < 10) {
          day = "0" + day;
        }
        var hour = "00" + date.getHours();
        hour = hour.substr(hour.length - 2);
        var minute = "00" + date.getMinutes();
        minute = minute.substr(minute.length - 2);
        var second = "00" + date.getSeconds();
        second = second.substr(second.length - 2);
        //构造一条文件数据给前端表格
        let param = {
          classifyId: this.docTypeForm.docType, //所属分类
          fileName: response.body.fileName, //文件名称
          fileFormat: response.body.fileExtName, //附件类型
          fileAddress: response.body.fileUrl, //文件地址
          uploadUser: sessionStorage.getItem("userId"),
          uploadTime: year +"-" +month +"-" +day +" " +hour +":" +minute +":" +second,
          fileSize: (Number(file.size) / 1024).toFixed(2), //文件大小
          belongtoProjectId: this.belongtoProjectId,
          belongtoProjectName: this.belongtoProjectName,
        };
        this.pageData.list.push(param);
        this.uploadFlag = false; //标记上传成功
        $(`.file-${file.id} .file-status`).html("上传成功");
        this.$emit('update:addFileList', this.pageData.list)
        this.$refs.uploader.removeFile(file, true);

        // // {
        // {
        //   // 移除上传弹窗的列表项
        //   // 在ui上移除
        //   let index = this.fileList.findIndex(ele => ele.id === file.id);
        //   this.fileList.splice(index, 1);
        // }
        // // }

        // 201908151528 如果传入了有效的 businessId 则立即保存到附件表 (否则 是 新增单据, 需 等待相应页面的保存操作后在相应业务接口自行保存到附件表)
        if (this.businessIds && !this.businessIds.startsWith('-')) {
          const list4Save = [
            {
              ...param,
              businessId: this.businessIds
            }
          ];
          list4Save.length > 0 && this.$http.post(this.api.accessoryInfoSave, list4Save).then(res => {
            if (res.data && res.data.code === "200") {
              // 重新查询
              this.getData(this.businessIds).then(() => {
                this.$emit('update:addFileList', this.pageData.list)
              });
            }
          })
        }
      
      } else {
        this.uploadError = true;
        this.$alert("上传文件发生异常", "提示", {
          confirmButtonText: "确定"
        });
        $(`.file-${file.id} .file-status`).html("文件上传失败！");
      }
    },
    onError(errorMessage) {
      this.$message.error(errorMessage);
    },

    fileSize(size) {
      return WebUploader.Base.formatSize(size);
    },
    //开始上传文件
    startUploadFile(file) {
      this.$refs.uploader.upload(file);
    },

    //停止上传文件(暂停)
    stopUploadFile(file) {
      this.$refs.uploader.stop(file);
    },
    //移除下载中的文件
    removeUploadFile(file) {
      this.$confirm("确认要取消上传吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          const that = this;
          // 取消并中断文件上传
          this.$refs.uploader.cancelFile(file);

          // 在队列中移除文件
          this.$refs.uploader.removeFile(file, true);

          // 在ui上移除
          let index = this.fileList.findIndex(ele => ele.id === file.id);
          this.fileList.splice(index, 1);
        })
        .catch(() => {});
    },

    //--------------------文件上传相关方法 end

    //--------------------文件下载方法  start
    handleDownload(file) {
      axios({
        method: "post",
        url: this.api.sySFileDownload,
        data: {
          fileUrl: file.fileAddress
        },
        responseType: "blob"
      })
        .then(response => {
          this.download(response.data, file.fileName);
        })
        .catch(error => {
          this.$message.error("文件下载出错了，请稍后再试！");
        });
    },

    // 下载文件
    download(data, docName) {
      if (!data) {
        return;
      }
      let url = window.URL.createObjectURL(new Blob([data]));
      let link = document.createElement("a");
      link.style.display = "none";
      link.href = url;
      link.setAttribute("download", docName);
      document.body.appendChild(link);
      link.click();
      URL.revokeObjectURL(link.href);
    },
    /**
     * 根据 树 和 节点id 查找相应节点
     */
    findTreeNodeById(id, treeData, options) {
      options = options || {};
      const children = options.children = options.children || 'children';
      for (let i = 0; i < treeData.length; i++) {
        const node = treeData[i];
        if (node.id === id) {
          return node;
        }
        const t = node[children] && this.findTreeNodeById(id, node[children], options);
        if (t) {
          return t;
        }
      }
      return null;
    },
    handlePreviewFile (row) {
      window.open(row.fileAddress);
    }
  }
};
</script>

<style lang="scss" scoped>
.docManagerWrap {
  position: relative;
  height: 100%;
  box-sizing: border-box;

  .docManagerWrap-msg {
    height: 100%;
    padding: 10px;
    position: relative;

    .head-btn {
      position: absolute;
      right: 10%;
      top: 90px;
    }

    .docManagerWrap-head-Top {
      position: absolute;
      margin-top: 90px;
      font-size: 0.8rem;
      margin-left: 22px;
      color: #606266;
    }

    .docManagerWrap-head-msg {
      /*border: 1px solid #ccc;*/
      position: absolute;
      margin-top: 80px;
      width: 76%;
      padding: 10px;
      margin-left: 10% !important;
      border-radius: 20px;
      /*box-shadow: 2px 2px 5px #ccc;*/
    }

    .docManagerWrap-head {
      position: absolute;
      height: 200px;
      background: #fff;
      width: 100%;
      padding-top: 20px;
      border-radius: 20px;
      box-sizing: border-box;
      box-shadow: 2px 2px 5px #ccc;
    }

    .docManagerWrap-Top {
      margin-top: 10px;
      border-radius: 20px;
      height: 100%;
      /*background-color: #f00;*/
      width: 100%;
      position: relative;
      box-shadow: 2px 2px 5px #ccc;

      .docManagerWrap-Bottom {
        /*background: #ff0;*/
        height: 100%;
        width: 100%;
        border: 1px solid #ccc;
        border-radius: 20px;
        box-sizing: border-box;
        overflow: auto;

        .docManagerWrap-Bottom-table {
          height: 100%;
          padding: 30px 10px 40px 10px;
          box-sizing: border-box;
        }
      }
    }
  }
}

////上传组件的样式begin
/deep/ .el-dialog--small {
  width: auto;
}

.file-panel {
  width: 800px;
  margin-top: 10px;
  box-shadow: 0 2px 12px 1px rgba(0, 0, 0, 0.1);

  > h2 {
    height: 40px;
    line-height: 40px;
    padding: 0 10px;
    border-radius: 4px 4px 0 0;
    border-bottom: 1px solid #ccc;
    background-color: #fff;
  }

  .file-list {
    position: relative;
    height: 360px;
    overflow-y: auto;
    background-color: rgb(250, 250, 250);
  }

  .file-list > ul {
    padding-bottom: 5px;
  }

  .file-item {
    position: relative;
    height: 50px;
    line-height: 50px;
    padding: 2px 10px;
    border-bottom: 1px solid #ccc;
    background-color: #fff;
    z-index: 1;

    > li {
      display: inline-block;
    }
  }

  .file-type {
    width: 24px;
    height: 24px;
    vertical-align: -5px;
  }

  .file-name {
    width: 60%;
    margin-left: 10px;
  }

  .file-size {
    width: 10%;
  }

  .file-status {
    width: 20%;
  }

  .file-operate {
    width: 18%;
    position: absolute;
    right: 0;
    text-align: right;
    padding-right: 10px;

    > a {
      padding: 8px 3px;
      cursor: pointer;
      color: #666;

      &:hover {
        color: #ff4081;
      }
    }
  }

  .progress {
    height: 50px;
    position: absolute;
    top: 0;
    left: 0;
    height: 50 - 1;
    width: 0;
    background-color: #e2edfe;
    z-index: -1;
  }

  .no-file {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 16px;
  }
}
////上传组件的样式end
</style>
<style lang="less" scoped>
    .uploadDialog {
        /deep/ .el-dialog__header{
            display: none;
        }
    }
/deep/ .upload-demo-el {
  width: 100%;
  height: 100%;
  /*background-color: #ff0;*/
  padding: 80px;
  text-align: center;
}
/deep/ .upload-demo-el /deep/ .el-upload {
  height: 40px;
  width: 90px;
  border: none;
}
.docManagerWrap-Top /deep/ .el-input__inner {
  width: 100% !important;
}
/deep/ .docManagerDialog /deep/ .el-input__inner {
  width: 13rem !important;
}
/deep/ .add-cascader /deep/ .el-input__inner {
  width: 100% !important;
}
/deep/ .Permissio-Selection /deep/ .el-input__inner {
  width: 100% !important;
  height: 100px;
}
/deep/ .el-dialog__wrapper {
  position: absolute !important;
}

/deep/ .v-modal {
  position: absolute !important;
}

/deep/ .content {
  position: relative !important;
}
.iconfont {
  font-size: 25px;
}
</style>



// WEBPACK FOOTER //
// src/module/system/sysPropertyRightManager/tabs/accessoryList.vue